import { render, staticRenderFns } from "./RoomBoardDrawer.vue?vue&type=template&id=ac80f25a&scoped=true&"
import script from "./RoomBoardDrawer.vue?vue&type=script&lang=js&"
export * from "./RoomBoardDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoardDrawer.vue?vue&type=style&index=0&id=ac80f25a&lang=scss&scoped=true&"
import style1 from "./RoomBoardDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac80f25a",
  null
  
)

export default component.exports